import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-active"]

import { onMounted, onUnmounted, ref } from 'vue'

interface EMITS {
  (e: 'files-dropped', val: File[])
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InputFileDrop',
  props: {
  disabled: { type: Boolean, default: false }
},
  emits: ["files-dropped"],
  setup(__props, { emit: __emit }) {


const emits = __emit
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
const active = ref(false)
let inActiveTimeout: any = null

function onDrop(event: DragEvent) {
  setInactive()
  emits('files-dropped', event.dataTransfer?.files ? [...event.dataTransfer.files] : [])
}

function preventDefaults(event) {
  event.preventDefault()
}
function setActive() {
  active.value = true
  clearTimeout(inActiveTimeout)
}
function setInactive() {
  inActiveTimeout = setTimeout(() => {
    active.value = false
  }, 50)
}

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
})

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "input-file-drop-box",
    "data-active": active.value,
    onDragenter: _withModifiers(setActive, ["prevent"]),
    onDragover: _withModifiers(setActive, ["prevent"]),
    onDragleave: _withModifiers(setInactive, ["prevent"]),
    onDrop: _withModifiers(onDrop, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default", { dropZoneActive: active.value })
  ], 40, _hoisted_1))
}
}

})